import styled, { createGlobalStyle } from "styled-components";
    const GlobalStyles = createGlobalStyle`
    *{
        margin: 0px;
        padding: 0px;
        box-sizing: border-box;
        font-family: 'Mulish',Arial, Helvetica, sans-serif;
        
    }
    button{
        }

`;
export default GlobalStyles;

export const FlexContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100vh;
`;

export const Container = styled.div`
    padding: 20px 20px;
    @media only screen and (max-width: 992px) {
        padding: 20px;
    }
`;
export const LoadingContainer = styled.div`
    height: 100vh;
    width: 100%;
    background-color: rgba(223, 223, 223, 0.11);
    position: absolute;
    /* z-index: 1000; */
`;